import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { Loader } from "components/common/Icons/Loader/Loader";
import { RightIcon } from "components/common/Icons/RightIcon";
import { useImageCropperAction } from "./useImageCropperAction";

export const DesktopAction = () => {
    const { handleClick, isActive, imageLoaded } = useImageCropperAction();

    return (
        <div className="w-full">
            <div
                className={`cursor-pointer ${
                    !isActive ? "bg-irGray-400 dark:bg-darkSurface-600" : "bg-irBlue-200 dark:bg-darkPrimary-100"
                } text-white text-center text-2xl flex items-center justify-center gap-2 capitalize font-semibold px-6 py-4 rounded-xl ${
                    !isActive
                        ? "hover:bg-irGray-600 dark:hover:bg-darkSurface-500"
                        : "hover:bg-irBlue-400 dark:hover:bg-darkPrimary-100"
                } dark:border-darkSurface-100`}
                onClick={(e) => {
                    if (!isActive) return;
                    e.stopPropagation();
                    handleClick();
                }}
                data-testid="crop-button"
            >
                <div className="capitalize">
                    {!imageLoaded
                        ? "Loading"
                        : !isActive
                          ? capitalize(translateFunc("common:processing"))
                          : capitalize(`${translateFunc("crop")} ${translateFunc("image")}`)}
                </div>
                {!isActive ? (
                    <Loader className="stroke-white" width={18} height={18} />
                ) : (
                    <RightIcon className="fill-white" />
                )}
            </div>
        </div>
    );
};
